<script>
import { notify } from '@/helpers/notify' 

import {
  required
} from "vuelidate/lib/validators";


export default {
    name: 'UpdateModal',
    props:[
        "data",
        "openModal"
    ],
    data() {
        return {
            submitted: false,
            id:null,
            form:{
                fname:'',
                lname:'',
                username: '',
                password: ''
            },
            ilList : [],
            bucakList:[],
            tariffList :[],
            userList:[],
            apartmentList:[]
        };
    },
     validations: {
        form:{
            province : { required },
            township: { required },
            phonenumber: { required },   
            fname: { required },
            lname: { required },
        },
    }, 
    computed:{
        modalTitle(){ return  "Ön Başvuru Güncelle" },
    },  
    watch:{
        openModal(cnt) {
            
            this.form = {
                fname:'',
                lname:'',
                username: '',
                password: ''
            }
            
            this.id = this.data

            this.$http.get(`members/${this.data}`)
                .then((response) =>this.form = response.data )
             
            if(cnt == 1){
                this.getUserList()   
                this.getApartmentList()
                this.getTariffList()
                this.setSelected({ id : 0 },'il')
            }
        },
    },
    methods: { 
        save(){
            this.submitted = true;
            this.$v.form.$touch();

            if(this.$v.form.$invalid) return;
                this.$http.put(`members/kb_update`, { ...this.form, id:this.id, type:["service", "fullname", "contact", "dealer"] })
                .then((resp) => notify.success(resp.data.message))
                
        },
     
        async getUserList(){
            await this.$http.post('/users?output=one&fields=id,name')
            .then(response => this.userList = response.data)
            
        },

        async getTariffList(){
            await this.$http.post('/tariff?output=one&fields=id,name')
            .then(resp => {
                this.tariffList = resp.data
            })
            
        },
        
        async setSelected(val,event){
            const object = event + 'List' 
            const { id } = val
            const response = await this.$http.post(`/address/${event}/${id}`)

            if(response.data.error) return;
            this[object] = response.data;
        },

        async getApartmentList(){
            await this.$http.post('/apartman?output=one&fields=apartments.id,apartments.name')
            .then(resp => { this.apartmentList = resp.data })
            
        },

        close(){
            this.$parent.$bvModal.hide('update_application_modal')
        }

    },
};
</script>

<template>
<b-modal id="update_application_modal"  :title="modalTitle"  size="lg" no-close-on-backdrop hide-footer>
    <div class="row">
        <div class="col-md-12">
                <div class="alert alert-warning">
                {{ form.fname }}
                {{ form.lname }}
                <br>
                Kullanıcı adı : {{ form.username}}
                <br>
                Şifre :{{ form.password}}
            </div>
        </div>
    </div>  
    <form class="needs-validation">
        <div class="row d-flex flex-wrap mb-1"> 
            <label class="col-sm-4 col-form-label col-form-label" for="isim">İsim</label>
            <div class="col">
                <input
                id="identity_name"
                v-model="form.fname"
                type="text"
                class="form-control"
                placeholder="İsim"
                :class="{
                    'is-invalid': submitted && $v.form.fname.$error,
                }"
                />
                <div
                v-if="submitted && $v.form.fname.$error"
                class="invalid-feedback"
                >
                <span v-if="!$v.form.fname.required"
                    >Bu alanı doldurmak zorunludur.</span
                >
                </div>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-4 col-form-label col-form-label" for="Soyisim">Soyisim</label>
            <div class="col">
                <input
                id="identity_last"
                v-model="form.lname"
                type="text"
                class="form-control"
                placeholder="Soyisim"
                
                :class="{
                    'is-invalid': submitted && $v.form.lname.$error,
                }"
                />
                <div
                v-if="submitted && $v.form.lname.$error"
                class="invalid-feedback"
                >
                <span v-if="!$v.form.lname.required"
                    >Bu alanı doldurmak zorunludur.</span
                >
                </div>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-4 col-form-label col-form-label" for="phonenumber">Telefon1 <span class="text-danger" style="font-size: 11px;">Mesajlar bu numaraya gider</span></label>
            <div class="col">
                <input
                    id="phonenumber"
                    v-model="form.phonenumber"
                    type="text"
                   
                    class="form-control"
                    placeholder="Telefon Numarası"
                    :class="{
                    'is-invalid': submitted && $v.form.phonenumber.$error,
                    }"
                />
                <div
                v-if="submitted && $v.form.phonenumber.$error"
                class="invalid-feedback"
                >
                <span v-if="!$v.form.phonenumber.required"
                    >Bu alanı doldurmak zorunludur.</span
                >
                </div>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-4 col-form-label col-form-label" for="phonenumber2">Telefon2</label>
            <div class="col">
                <input
                    id="phonenumber2"
                    v-model="form.phonenumber2"
                    type="text"
                    class="form-control"
                    placeholder="Telefon2"
                />
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="email">E-Posta</label>
            <div class="col">
                <input
                id="email"
                v-model="form.email"
                type="text"
                class="form-control"
                placeholder="E-Posta"
                />
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="il">İlçe</label>
            <div class="col">
                <v-select
                    label="name" 
                    v-model="form.province"
                    :options="ilList" 
                    :reduce="country => country.id"
                    @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="bolge">Bölge</label>
            <div class="col">
                <v-select 
                label="name"  
                v-model="form.township"                    
                :options="bucakList" 
                :reduce="country => country.id"><span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="address">Adres Detay</label>
            <div class="col">
                <input
                    id="address" 
                    v-model="form.address"
                    type="text"
                    class="form-control"
                    placeholder="Adres Açıklaması"
                />
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="adress">Servis</label>
            <div class="col">
                <v-select 
                    v-model="form.tariff_id"
                    :options="tariffList"
                    :reduce="r => r.id"
                    label="name"
                    >
                <span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="description">Açıklama</label>
            <div class="col">
                <input
                    id="description" 
                    v-model="form.description"
                    type="text"
                    class="form-control"
                    placeholder="Açıklama"
                />
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="apartment_id">Apartman Sistemi İse Seçiniz</label>
            <div class="col">
                <v-select 
                    label="name"  
                    v-model="form.apartment_id"     
                    :reduce="apt => apt.id"                 
                    :options="apartmentList">
                    <span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
        </div>
          <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="user_id">Bayisi</label>
            <div class="col">
                <v-select 
                    label="name"  
                    v-model="form.user_id"     
                    :reduce="user => user.id"         
                    :options="userList">
                    <span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <button class="btn btn-light" type="button" @click="close()">Vazgeç</button>
            <button class="btn btn-primary" type="button" @click="save()">Güncelle</button>
        </div>
    </form>
</b-modal>
</template>